/**
 * Whether a pathname is the Access Link route.
 *
 * Access Links are authorised by the share token in the path of the `Referer` header, so REST
 * requests on this route need a `referrerPolicy` that preserves it.
 *
 * Deliberately a pathname test rather than a route-manager lookup: `cfetch` is not a hook, runs
 * outside the router, and must stay dependency-light. Mirrors the `ACCESS_LINK` route pattern in
 * `@confluence/named-routes` — keep in step with it if that ever moves.
 */
const ACCESS_LINK_PATH_PREFIX = '/wiki/access-link/';

export function isAccessLinkPath(pathname?: string): boolean {
	// SSR sets its own `Referer`, so the browser's referrer policy is not consulted there.
	if (pathname === undefined) {
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		const isServerRendering = Boolean(process.env.REACT_SSR);
		if (isServerRendering || typeof globalThis.window?.location === 'undefined') {
			return false;
		}
	}

	const path = pathname ?? window.location.pathname;

	if (!path || !path.startsWith(ACCESS_LINK_PATH_PREFIX)) {
		return false;
	}

	// The token is a single path segment, so reject anything nested beneath the route.
	const token = path.slice(ACCESS_LINK_PATH_PREFIX.length).replace(/\/$/, '');

	return token.length > 0 && !token.includes('/');
}
